module.exports = __webpack_public_path__ + "static/media/3360.a771a161.jpg";